import { Component, Renderer2 } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoginPageComponent } from "../../pages/login-page/login-page.component";

@Component({
  selector: 'app-login-layout',
  imports: [RouterOutlet],
  templateUrl: './login-layout.component.html',
  styleUrl: './login-layout.component.scss'
})
export class LoginLayoutComponent {

  constructor(private renderer: Renderer2) { }

  classes = [
    'login-layout',
  ]

  ngOnInit(): void {
    // Add class to the body tag
    this.classes.forEach((className) => {
      this.renderer.addClass(document.body, className);
    });
  }

  ngOnDestroy(): void {
    // Clean up by removing the class
    this.classes.forEach((className) => {
      this.renderer.removeClass(document.body, className);
    });
  }
}
